import React from 'react';
import classNames from 'classnames';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { PayloadStates } from '@lore/utils';

export default function EventImageData(props) {
  const { upload } = props;

  const launch = useDialogLauncher();

  const evaluationEventEducator = useConnect('evaluationEventEducator.byId', {
    id: upload.data.evaluationEventEducatorId
  });

  const event = useConnect('event.byId', {
    id: evaluationEventEducator.data.eventId
  }, {
    enabled: !!evaluationEventEducator.data.eventId
  });

  const activity = useConnect('tag.byId', {
    id: event.data?.activityId
  }, {
    enabled: !!event.data?.activityId
  });

  function onClickEvent() {
    launch(DialogManager.EventManage.Config(event.id));
  }

  function onClickUpload() {
    window.open(upload.data.url, '_blank').focus();
  }

  return (
    <div className="space-y-2 text-sm">
      <div>
        <div>
          Event
        </div>
        {event.state === PayloadStates.FETCHING ? (
          <div>
            ...
          </div>
        ) : (
          <div className="text-cs-orange-500 hover:text-cs-orange-300 cursor-pointer" onClick={onClickEvent}>
            {event.data.title || activity.data.name || '...'}
          </div>
        )}
      </div>
      <div>
        <div>
          File
        </div>
        <div className={classNames(
          'flex space-x-1 items-center',
          'text-cs-orange-500 hover:text-cs-orange-300 cursor-pointer',
          'break-all'
        )} onClick={onClickUpload}>
          <span>
            {upload.data.name}
          </span>
          <ArrowTopRightOnSquareIcon className="h-4 2-4" />
        </div>
      </div>
    </div>
  );
}
